import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


// plugins
import './plugins';

//Helper
import Helper from './helpers/helper'

/**
 * Global decleration
 */

// style

// configs
Vue.config.productionTip = false
Helper.axoisglobalconfig();

/**
 * Network status listner
 * this will checked or listen to network connection
 */

/**
 * Check network status connection on load
 */
// if (navigator.onLine) {
//   store.commit('updatenetworkstatus', true);
// } else {
//   store.commit('updatenetworkstatus', false);
// }
fetch('https://picsum.photos/id/237/200/300').then(() => {
  store.commit('updatenetworkstatus', true);
}).catch(() => {
  store.commit('updatenetworkstatus', false);
})

/**
 * Listen network status
 */
window.addEventListener('offline', () =>  { 
  store.commit('updatenetworkstatus', false);
});

window.addEventListener('online', () => { 
  store.commit('updatenetworkstatus', true);
});

console.log('process', process.env.NODE_ENV)

if(process.env.NODE_ENV.trim() != 'development') {
  console.log = function() {}
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
